import { Model } from '@chaysehartsuff/active-html';

export default class PublishedBlog extends Model {

    id;
    blog_id;
    title;
    description;
    content;
    publish_date;
    is_published;
    created_at;
    updated_at;

}